import React, { useState, useEffect, useRef } from "react";
import * as d3 from "d3";

const AutoRefreshTimer = ({
  offLabel = "Auto Refresh",
  onLabel = "Auto Refresh",
  duration = 60,
  onRefresh,
  initialState = false,
}) => {
  const [isActive, setIsActive] = useState(initialState);
  const [timeLeft, setTimeLeft] = useState(duration);
  const timerRef = useRef(null);
  const svgRef = useRef(null);

  useEffect(() => {
    if (isActive) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            onRefresh();
            return duration;
          }
          return prevTime - 1;
        });
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      setTimeLeft(duration);
    }
    return () => clearInterval(timerRef.current);
  }, [isActive, duration, onRefresh]);

  useEffect(() => {
    drawClock();
  }, [timeLeft, isActive]);

  const toggleTimer = () => {
    setIsActive(!isActive);
  };

  const drawClock = () => {
    const size = 16;
    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    // Draw clock face
    svg
      .append("circle")
      .attr("cx", size / 2)
      .attr("cy", size / 2)
      .attr("r", size / 2 - 1)
      .attr("fill", "none")
      .attr("stroke", isActive ? "#93c5fd" : "#9ca3af")
      .attr("stroke-width", 1);

    if (isActive) {
      // Draw pie chart
      const arc = d3
        .arc()
        .innerRadius(0)
        .outerRadius(size / 2 - 1)
        .startAngle(0)
        .endAngle(2 * Math.PI * (1 - timeLeft / duration));

      svg
        .append("path")
        .attr("d", arc)
        .attr("fill", "#93c5fd")
        .attr("transform", `translate(${size / 2}, ${size / 2})`);
    }
  };

  return (
    <button
      onClick={toggleTimer}
      className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm transition-colors duration-300 ${
        isActive
          ? "bg-blue-500/40 text-gray-200"
          : "bg-gray-700 text-gray-300 hover:bg-gray-600"
      }`}
    >
      <svg ref={svgRef} width="16" height="16"></svg>
      <span>{isActive ? onLabel : offLabel}</span>
      {isActive && <span className="font-mono">{timeLeft}s</span>}
    </button>
  );
};

export default AutoRefreshTimer;
